module.exports = __webpack_public_path__ + "img/note4.bed5362d.svg";